import { useCampfireFetch } from '../../../global/network/useCampfireFetch';

interface GetRefereeSubmissionRequest {
  submissionToken: string;
}

interface GetRefereeSubmissionResponse {
  refereeContact: {
    id: string;
    completedTaskId: string;
    refereeName: string;
    refereeEmail: string;
    isCompleted: boolean;
    dateInvited: string | null;
    dateSubmitted: string | null;
    submissionToken: string;
    refereeMessage: string | null;
    task: {
      title: string;
      instructions: string | null;
      taskFields: Array<{
        taskFieldId: string;
        fieldName: string;
        fieldType: string;
        isRequired: boolean;
        selectOptions: string[] | null;
        allowsMultiple: boolean;
        placeholder: string | null;
        helpText: string | null;
      }>;
    };
    volunteer: {
      firstName: string;
      lastName: string;
      preferredName: string | null;
    } | null;
  };
}

interface SubmitRefereeDataRequest {
  submissionToken: string;
  fieldValues: Array<{
    taskFieldId: string;
    value: string;
  }>;
}

interface SubmitRefereeDataResponse {
  success: boolean;
  message: string;
}

export function useRefereeCheckActions() {
  const getRefereeSubmission = useCampfireFetch<GetRefereeSubmissionResponse>({
    defer: true,
    withAuth: false,
  });

  const submitRefereeData = useCampfireFetch<SubmitRefereeDataResponse>({
    defer: true,
    withAuth: false,
  });

  return {
    getRefereeSubmission,
    submitRefereeData,
  };
}